<div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'"><mat-spinner style="margin:0 auto; margin-top: 15%;" ></mat-spinner></div>

<div class="customers" >
    <div class="card">
        <div class="card-body" style="padding: 20px;">


            <div class="row">
                <div class="col-sm-6">
                    <p class="titulo-card-rojo">Agendar Tutoría {{jardinTutoria.numeroTutoria}}</p>
                </div>
                <div class="col-sm-6" style="text-align: right;">
                    <button type="button" (click)="volver()" class="btn btn-light btn-send" style="background-color: #FFDCE7;
                    color: #EE363D;
                    border: 1px solid;
                    width: 120px;
                    height: 40px;"> Volver</button>
                </div>
            </div>



            <div>

                

                <div class="row" >

                    
                    <div class="col-md-12" style="margin-bottom: 20px;">
                        <div class="row text-center mb-4">
                            <div class="col-md-4">
                                <div class="btn-group">
                                <div
                                    class="btn btn-primary"
                                    mwlCalendarPreviousView
                                    [view]="view"
                                    [(viewDate)]="viewDate"
                                    (viewDateChange)="closeOpenMonthViewDay()"
                                >
                                    Anterior
                                </div>
                                <div
                                    class="btn btn-outline-secondary"
                                    mwlCalendarToday
                                    [(viewDate)]="viewDate"
                                >
                                    Hoy
                                </div>
                                <div
                                    class="btn btn-primary"
                                    mwlCalendarNextView
                                    [view]="view"
                                    [(viewDate)]="viewDate"
                                    (viewDateChange)="closeOpenMonthViewDay()"
                                >
                                    Siguiente
                                </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):locale:weekStartsOn }}</h3>
                            </div>
                            <div class="col-md-4">
                                <div class="btn-group">
                                <div
                                    class="btn btn-primary"
                                    (click)="setView(CalendarView.Month)"
                                    [class.active]="view === CalendarView.Month"
                                >
                                    Mes
                                </div>
                                <div
                                    class="btn btn-primary"
                                    (click)="setView(CalendarView.Week)"
                                    [class.active]="view === CalendarView.Week"
                                >
                                    Semana
                                </div>
                                <div
                                    class="btn btn-primary"
                                    (click)="setView(CalendarView.Day)"
                                    [class.active]="view === CalendarView.Day"
                                >
                                    Día
                                </div>
                                </div>
                            </div>
                        </div>
                            
                        <div [ngSwitch]="view">
                            <mwl-calendar-month-view
                                *ngSwitchCase="CalendarView.Month"
                                [viewDate]="viewDate"
                                [events]="events"
                                [refresh]="refresh"
                                [locale]="locale"
                                [weekStartsOn]="weekStartsOn"
                                [activeDayIsOpen]="false"
                                (dayClicked)="changeDay($event.day.date)"                               
                            >
                            </mwl-calendar-month-view>
                            <mwl-calendar-week-view
                                *ngSwitchCase="CalendarView.Week"
                                [viewDate]="viewDate"
                                [events]="events"
                                [refresh]="refresh"
                                [locale]="locale"
                                [dayStartHour]="8"
                                [dayEndHour]="20"
                                [weekStartsOn]="weekStartsOn"
                                (eventClicked)="agendarModal('Clicked', $event.event)"
                                
                            >
                            </mwl-calendar-week-view>
                            <mwl-calendar-day-view
                                *ngSwitchCase="CalendarView.Day"
                                [viewDate]="viewDate"
                                [events]="events"
                                [refresh]="refresh"
                                [locale]="locale"
                                [dayStartHour]="8"
                                [dayEndHour]="20"
                                (eventClicked)="agendarModal('Clicked', $event.event)"
                            >
                            </mwl-calendar-day-view>
                        </div>
                            

                    </div>
                </div>  


   
            </div>


        </div>
    </div>
</div>


<ng-template #modalContent let-close="close">
    <div class="modal-header">
      <h5 class="titulo-card-rojo">Confirmar Agenda Tutoría</h5>
      <button type="button" class="close" (click)="close()" style="background: none;
      border: none;
      font-size: xx-large;">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div>
        Tutor(a):
        <pre class="inputModalAgenda">{{ modalData?.tutor?.nombres  }} {{ modalData?.tutor?.apellidos  }}</pre>
      </div> 
      <div>
        Fecha:
        <pre class="inputModalAgenda">{{ modalData?.event.start | date:'dd/MM/yyyy'}}</pre>
      </div>
      <div>
        Hora:
        <pre class="inputModalAgenda">{{ modalData?.event.start | date:'hh:mm'}}</pre> 
      </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="close()" style="background-color: #3E445E;color: #FFFFFF;">
            Cancelar
        </button>
        <button type="button" class="btn btn-outline-secondary" (click)="confirmarAgenda(modalData)" style="background-color: #EE366B;color: #FFFFFF;">
            Confirmar
        </button>
    </div>
  </ng-template> 

